module.exports = __webpack_public_path__ + "img/icon-market-products.6342c021.png";